import { WageTypeEnum } from '@akiba/models_beta_temp';

export enum LocalStorageEnum {
  ViewerInfoResponse = 'viewerInfoResponse',
  RememberUser = 'rememberUser',
  CurrentUserCompany = 'currentUserCompany',
  CompanySSOInfo = 'companySSOInfo',
  Locale = 'locale'
}

export enum DisplayTypeEnum {
  List = 'list',
  Table = 'table',
  TableRow = 'tableRow'
}

export enum AlertTypeEnum {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Danger = 'danger',
  Primary = 'primary',
  Secondary = 'secondary',
  Light = 'light',
  Dark = 'dark'
}

export enum GenericButtonTextEnum {
  Cancel = 'app.buttons.cancel',
  Deny = 'app.buttons.deny',
  Delete = 'app.buttons.delete',
  Accept = 'app.buttons.accept',
  Confirm = 'app.buttons.confirm',
  Approve = 'app.buttons.approve'
}

export interface WageTypeDisplayFrequency {
  wageType: WageTypeEnum;
  displayFrequency: string;
}
